export const COVALENT_TOKEN_BLACKLIST = [
    '0x41c37a4683d6a05adb31c39d71348a8403b13ca9',
    '0xefa1aa32976e3f19da5e649fdeec77b72469bfb3',
    '0x7bfe43e475ebea07fa03337da551e18502c8793c',
    '0x95e9464b5cc3bf81210259812b51665a437aa11b',
    '0xc229cc41f523f165436f2d52c62b80602cd76f51',
    '0xfe18be6b3bd88a2d2a7f928d00292e7a9963cfc6',
    '0xc011a73ee8576fb46f5e1c5751ca3b9fe0af2a6f',
    '0x467bccd9d29f223bce8043b84e8c8b282827790f',
]